import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfig } from '../Config/api.config';
@Injectable({
  providedIn: 'root'
})
export class WalletyRequestService {

  constructor(private http: HttpClient) {}

   getWalletyMeData(requestId: string): Observable<any> {

  const headers = new HttpHeaders({
    'X-Api-Key': ApiConfig.apiKey
  });

  const params = new HttpParams()
    .set('requestId', requestId);

  return this.http.get(
    `${ApiConfig.baseUrl}/WalletyMe/get-request-data`,
    {
      headers,
      params
    }
  );
}
  postPay(requestId: string, 
          paymentMethodId: string, 
          authorizationPin: string, 
          voucherPin: string,
          serviceFeeAmount: number, 
          totalAmount: number): Observable<any> {
    const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey
    });

    const request = {
        requestId,
        paymentMethodId,
        authorizationPin,
        voucherPin,
        serviceFeeAmount,
        totalAmount
    };
    return this.http.post(
      `${ApiConfig.baseUrl}/WalletyMe/make-payment`,
      request,
      {
        headers
      }
    );
  }
   
  postRejectRequest(requestId: string): Observable<any> {
  const headers = new HttpHeaders({
    'X-Api-Key': ApiConfig.apiKey
  });

  const params = new HttpParams()
    .set('requestId', requestId);

  return this.http.post(
    `${ApiConfig.baseUrl}/WalletyMe/reject-request`,
    null,
    {
      headers,
      params
    }
  );
}
}